(() => {
class WeaveplaceProduct extends HTMLElement {
 connectedCallback(){if(this._ready)return;this._ready=true;this.gallery=this.querySelector('.wp-pdp__gallery');this._wpBuildGalleryGroups();this.slides=[...this.querySelectorAll('.wp-pdp__slide')];this.thumbs=[...this.querySelectorAll('.wp-pdp__thumb')];this.info=this.querySelector('.wp-pdp__info');this.form=this.querySelector('.wp-pdp__form');this.variants=JSON.parse(this.querySelector('[data-variants]')?.textContent||'[]');this.variantInput=this.querySelector('[data-variant-id]');this.atc=this.querySelector('[data-atc]');this.label=this.querySelector('[data-atc-label]');this.msg=this.querySelector('[data-message]');this.price=this.querySelector('[data-price]');this.availability=this.querySelector('[data-availability]');document.body.classList.add('wp-pdp-page');this.initGallery();this.initLinkedColors();this.initMobileLinkedColors();this.initWishlist();this.initOptions();this.initMobilePanel();this.initDrawer();this.initMobileSizePicker();
  if(new URLSearchParams(location.search).get('wp_open_size')==='1'){
   const cleaned=new URL(location.href);cleaned.searchParams.delete('wp_open_size');
   history.replaceState(history.state,'',cleaned.pathname+cleaned.search+cleaned.hash);
   requestAnimationFrame(()=>requestAnimationFrame(()=>this.openMobileSizePicker()));
  }
  this._cartSubmitting=false;this.form?.addEventListener('submit',e=>this.addToCart(e));
  // Reconcile both purchase buttons after breakpoint/orientation changes.
  this._wpPurchaseResize=()=>{if(this.isConnected)this._wpRenderPurchaseButtons();};
  window.addEventListener('resize',this._wpPurchaseResize,{passive:true});
  this._wpRenderPurchaseButtons();}


 // Liquid renders one thumbnail for every gallery group, including 2/3-cell groups.
 _wpBuildGalleryGroups(){
  const slides=[...(this.gallery?.querySelectorAll('.wp-pdp__gallery-track > .wp-pdp__slide')||[])];
  this._wpMediaToGroup=slides.map((_,i)=>i);
  this._wpGroupToFirstMedia=slides.map((_,i)=>i);
 }

 initLinkedColors(){
  const links=[...this.querySelectorAll('[data-wp-linked-colors] .wp-pdp__linked-color')];
  const preview=this.querySelector('[data-wp-color-preview]');
  if(!links.length||!preview)return;
  const image=preview.querySelector('img');
  const heading=this.querySelector('.wp-pdp__linked-colors-heading span');
  const originalName=heading?.textContent||'';
  let activeLink=null;
  const show=link=>{
   if(!window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1024px)').matches)return;
   // The active colour already appears in the real gallery. Never overlay it:
   // doing so re-crops/reloads the same image and creates a visible jump.
   if(link.matches('.is-current, [aria-current="page"]')){
    hide();
    return;
   }
   const url=link.dataset.wpPreviewImage;
   if(!url)return;
   activeLink=link;
   image.src=url;
   image.alt=link.dataset.wpColorName||'';
   if(heading)heading.textContent=link.dataset.wpColorName||originalName;
   preview.classList.add('is-visible');
  };
  const hide=()=>{
   activeLink=null;
   preview.classList.remove('is-visible');
   if(heading)heading.textContent=originalName;
  };
  links.forEach(link=>{
   link.addEventListener('pointerenter',()=>show(link));
   link.addEventListener('pointerleave',hide);
   link.addEventListener('focus',()=>show(link));
   link.addEventListener('blur',hide);
  });
  this.addEventListener('keydown',event=>{if(event.key==='Escape'&&activeLink)hide()});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)hide()});
 }
 initMobileLinkedColors(){
  const links=[...this.querySelectorAll('[data-wp-linked-colors] .wp-pdp__linked-color')];
  const trigger=this.querySelector('[data-wp-open-mobile-colors]');
  const mini=this.querySelector('[data-wp-mobile-mini-colors]');
  if(!links.length||!trigger||!mini)return;
  const mobile=()=>matchMedia('(max-width:1023px)').matches;
  const current=links.find(link=>link.matches('.is-current,[aria-current="page"]'))||links[0];
  const shade=document.createElement('div');shade.className='wp-pdp__mobile-colors-shade';shade.hidden=true;
  const panel=document.createElement('section');panel.className='wp-pdp__mobile-colors-panel';panel.hidden=true;
  panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');panel.setAttribute('aria-label','Select Color');
  const handle=document.createElement('button');handle.type='button';handle.className='wp-pdp__mobile-colors-handle';handle.setAttribute('aria-label','Close color selection');handle.innerHTML='<span aria-hidden="true"></span>';
  const title=document.createElement('div');title.className='wp-pdp__mobile-colors-title';
  title.textContent=current.dataset.wpColorName||'Select Color';
  const list=document.createElement('div');list.className='wp-pdp__mobile-colors-list';
  const clip=document.createElement('div');clip.className='wp-pdp__mobile-colors-clip';
  let selected=current,priorFocus=null,priorOverflow=null,closeTimer=null;
  const items=[];
  const mark=link=>{
   selected=link;
   title.textContent=link.dataset.wpColorName||link.getAttribute('aria-label')||'';
   items.forEach(({link:other,item,chip})=>{
    const active=other===link;
    item.classList.toggle('is-current',active);
    chip.classList.toggle('is-preview',active);
    chip.classList.toggle('is-current',active);
    if(active)item.setAttribute('aria-selected','true');else item.removeAttribute('aria-selected');
   });
  };
  links.forEach((link,index)=>{
   // Each lower-right square has its own accessible click target, not one big button.
   const chip=document.createElement('button');chip.type='button';
   chip.className='wp-pdp__mobile-mini-chip'+(link===current?' is-current':'');
   chip.style.backgroundColor=link.style.getPropertyValue('--wp-linked-chip-color')||'#989898';
   chip.setAttribute('aria-label',(link.dataset.wpColorName||'Color')+' – view colors');
   chip.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();open(link)});
   mini.appendChild(chip);
   const item=document.createElement('a');item.className='wp-pdp__mobile-color-choice'+(link===current?' is-current':'');
   item.href=link.href;item.setAttribute('aria-label',link.dataset.wpColorName||'Color');
   if(link===current)item.setAttribute('aria-current','page');
   const photo=document.createElement('span');photo.className='wp-pdp__mobile-color-photo';
   if(link.dataset.wpPreviewImage){const img=document.createElement('img');img.src=link.dataset.wpPreviewImage;img.alt='';img.loading='eager';img.decoding='async';photo.appendChild(img)}
   item.append(photo);list.appendChild(item);items.push({link,item,chip});
   item.addEventListener('click',event=>{
    if(link===current){event.preventDefault();mark(link);close();return;}
    // Linked colours represent distinct Shopify products: follow their real URL.
    // Never add the previous colour's variant to cart.
    mark(link);
   });
  });
  panel.append(handle,title,list);clip.appendChild(panel);document.body.append(shade,clip);
  this.mobileColorsClip=clip;this.mobileColorsPanel=panel;this.mobileColorsShade=shade;
  const syncPosition=()=>{
   const card=this.querySelector('[data-mobile-panel]')||this.querySelector('.wp-pdp__info');
   const cardTop=card?.getBoundingClientRect().top??window.innerHeight-128;
   const headerBottom=document.querySelector('.section-header')?.getBoundingClientRect().bottom??0;
   const bottom=Math.max(0,Math.round(window.innerHeight-cardTop));
   const top=Math.max(0,Math.round(headerBottom));
   for(const element of [clip,shade]){element.style.setProperty('--wp-colors-bottom',bottom+'px');element.style.setProperty('--wp-colors-top',top+'px');}
  };
  this._wpSyncMobileColors=syncPosition;
  window.addEventListener('resize',syncPosition,{passive:true});
  window.visualViewport?.addEventListener('resize',syncPosition,{passive:true});
  const release=()=>{if(!priorOverflow)return;document.documentElement.style.overflow=priorOverflow.html;document.body.style.overflow=priorOverflow.body;priorOverflow=null;};
  const close=(handoff=false)=>{
   if(panel.hidden)return;
   panel.classList.remove('is-visible');shade.classList.remove('is-visible');
   trigger.setAttribute('aria-expanded','false');
   clearTimeout(closeTimer);
   closeTimer=setTimeout(()=>{
    if(panel.classList.contains('is-visible'))return;
    panel.hidden=true;shade.hidden=true;this.classList.remove('wp-pdp--colors-open');release();this._wpSyncCompactButton(this.variants.find(v=>String(v.id)===String(this.variantInput?.value)));
    if(handoff&&this.isConnected)this.openMobileSizePicker();
   },350);
   if(!handoff)(priorFocus?.isConnected?priorFocus:trigger).focus({preventScroll:true});
  };
  const open=(link=current)=>{
   if(!mobile()||this._drawerIsOpen)return;
   // A colour chip stays interactive while the size sheet is visible.
   // Switch sheets without allowing the size close timer to hide the new sheet.
   if(this._sizePopupOpen){
    this._wpBeginShadeHandoff();
    this.closeMobileSizePicker();
    clearTimeout(this._wpSizeCloseTimer);
    this._wpSizeClosing=false;
    this.sizePopup.hidden=true;
    this.sizeShade.hidden=true;
    this.classList.remove('wp-pdp--size-open');
    this._wpUnlockSizeScroll?.();
   }
   mark(link);
   if(panel.classList.contains('is-visible'))return;
   clearTimeout(closeTimer);syncPosition();priorFocus=document.activeElement;
   if(!priorOverflow)priorOverflow={html:document.documentElement.style.overflow,body:document.body.style.overflow};
   document.documentElement.style.overflow='hidden';document.body.style.overflow='hidden';
   panel.hidden=false;shade.hidden=false;this.classList.add('wp-pdp--colors-open');trigger.setAttribute('aria-expanded','true');this._wpSyncCompactButton(this.variants.find(v=>String(v.id)===String(this.variantInput?.value)));
   // During a size -> colour handoff, keep the dimming plane solid with no intermediate light frame.
   if(this._wpShadeHandoffActive)shade.classList.add('is-visible');
   requestAnimationFrame(()=>{if(!panel.hidden){panel.classList.add('is-visible');shade.classList.add('is-visible');this._wpSyncCompactButton(this.variants.find(v=>String(v.id)===String(this.variantInput?.value)))}});
  };
  trigger.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();open(current)});
  shade.addEventListener('click',()=>close());handle.addEventListener('click',()=>close());
  this._wpMobileColorKey=event=>{
   if(panel.hidden)return;
   if(event.key==='Escape'){event.preventDefault();close()}
   if(event.key==='Tab'){
    const controls=[handle,...list.querySelectorAll('a[href]')];
    if(event.shiftKey&&document.activeElement===controls[0]){event.preventDefault();controls.at(-1).focus()}
    else if(!event.shiftKey&&document.activeElement===controls.at(-1)){event.preventDefault();controls[0].focus()}
   }
  };
  document.addEventListener('keydown',this._wpMobileColorKey);
  this._wpMobileColorResize=()=>{if(!mobile())close()};
  window.addEventListener('resize',this._wpMobileColorResize,{passive:true});
  this._wpColorToSize=()=>{
   if(panel.hidden)return false;
   // Mini chips are a preview/entry point into the colour panel; only the
   // photographic links navigate to sibling product pages. Select Size always
   // hands off to the existing size picker on the currently displayed product.
   // Never use a previewed sibling as the current cart variant.
   this._wpBeginShadeHandoff();
   clearTimeout(closeTimer);
   panel.classList.remove('is-visible');shade.classList.remove('is-visible');
   panel.hidden=true;shade.hidden=true;this.classList.remove('wp-pdp--colors-open');
   trigger.setAttribute('aria-expanded','false');
   mark(current);
   release();
   this.openMobileSizePicker();
   return true;
  };
  this._wpColorIsOpen=()=>panel.classList.contains('is-visible');
  this._wpCloseMobileColors=()=>{clearTimeout(closeTimer);panel.classList.remove('is-visible');panel.hidden=true;shade.classList.remove('is-visible');shade.hidden=true;this.classList.remove('wp-pdp--colors-open');release()};
 }
 initGallery(){
  const desktop=()=>matchMedia('(min-width:1024px)').matches;
  const thumbRail=this.querySelector('.wp-pdp__thumbs');
  const progress=this.querySelector('.wp-pdp__progress-fill');
  let active=-1;
   // Shopify product videos: autoplay only the active gallery slide.
   // Browsers require muted + playsinline for reliable inline autoplay.
   const galleryVideos=[...this.gallery?.querySelectorAll('video.wp-pdp__video')||[]];
   galleryVideos.forEach(video=>{
     video.muted=true;
     video.defaultMuted=true;
     video.autoplay=true;
     video.loop=true;
     video.playsInline=true;
     video.controls=false;
     video.setAttribute('muted','');
     video.setAttribute('playsinline','');
     video.removeAttribute('controls');
   });
   const syncGalleryVideos=index=>{
     galleryVideos.forEach(video=>{
       const slide=video.closest('.wp-pdp__slide');
       const shouldPlay=!document.hidden&&this.slides[index]===slide;
       if(!shouldPlay){if(!video.paused)video.pause();return;}
       if(video.paused){const attempt=video.play();if(attempt?.catch)attempt.catch(()=>{});}
     });
   };
   this._wpSyncGalleryVideos=syncGalleryVideos;
   this._wpGalleryVisibility=()=>syncGalleryVideos(active);
   document.addEventListener('visibilitychange',this._wpGalleryVisibility);
  const mark=i=>{
    i=Math.max(0,Math.min(this.slides.length-1,i));
    if(active===i)return;
    active=i;
     syncGalleryVideos(i);
    this.thumbs.forEach((thumb,n)=>{const chosen=n===(this._wpGroupToFirstMedia?.[i]??i);thumb.classList.toggle('is-active',chosen);thumb.setAttribute('aria-current',chosen?'true':'false')});
    if(progress&&desktop()){
      const railHeight=progress.parentElement?.clientHeight||224;
      const thumbHeight=this.thumbs[this._wpGroupToFirstMedia?.[i]??i]?.getBoundingClientRect().height||40;
      const segment=Math.min(railHeight,Math.max(2,thumbHeight));
      const travel=Math.max(0,railHeight-segment);
      const ratio=this.slides.length>1?i/(this.slides.length-1):0;
      progress.style.height=segment+'px';
      progress.style.transform=`translate3d(0,${Math.round(travel*ratio)}px,0)`;
    }else if(progress){progress.style.transform=`scaleY(${(i+1)/Math.max(1,this.slides.length)})`;}const mobileProgress=this.querySelector('.wp-pdp__mobile-progress-fill');if(mobileProgress)mobileProgress.style.transform=`scaleY(${(i+1)/Math.max(1,this.slides.length)})`;
    // The thumbnail window uses native scrolling. Keep the selected image visible
    // without changing the currently visible group unnecessarily.
    if(desktop()&&thumbRail&&!this._suppressThumbSync){
      const chosen=this.thumbs[this._wpGroupToFirstMedia?.[i]??i];
      if(chosen){
        const view=thumbRail.getBoundingClientRect();
        const box=chosen.getBoundingClientRect();
        if(box.bottom>view.bottom+1)thumbRail.scrollTop+=box.bottom-view.bottom;
        else if(box.top<view.top-1)thumbRail.scrollTop+=box.top-view.top;
      }
    }
  };
  const go=i=>{
    if(this.mainSwiper)this.mainSwiper.slideTo(i,350);
    else if(this._wpNativeGoTo)this._wpNativeGoTo(i);
    else if(this.gallery){const slide=this.slides[i];if(slide)this.gallery.scrollTo({left:slide.offsetLeft,behavior:'smooth'});}
    mark(i);
  };
  this._wpGoToMedia=go;
  thumbRail?.addEventListener('wheel',()=>{this._thumbWheelAt=Date.now()},{passive:true});
  this.thumbs.forEach((b,i)=>{
    b.addEventListener('click',()=>go(this._wpMediaToGroup?.[i]??i));
    b.addEventListener('mouseenter',()=>{
      const groupIndex=this._wpMediaToGroup?.[i]??i;
      if(!desktop()||Date.now()-(this._thumbWheelAt||0)<120||active===groupIndex)return;
      this._suppressThumbSync=true;
      if(this.mainSwiper)this.mainSwiper.slideTo(groupIndex,240);
      else go(groupIndex);
      mark(groupIndex);
      this._suppressThumbSync=false;
    });
  });
  // WEAVEPLACE-style mobile vertical scroll on the grouped slide track.
  const track=this.gallery?.querySelector('.wp-pdp__gallery-track');
  let nativeScrollRaf=0;
  let mobileSlideCenters=[];
  let mobileCentersDirty=true;
  const measureMobileSlides=()=>{
    if(!track||desktop())return;
    // Cache layout metrics outside scroll frames. Image load and resize invalidate them.
    const first=this.slides[0]?.offsetTop||0;
    mobileSlideCenters=this.slides.map(slide=>slide.offsetTop-first+slide.offsetHeight/2);
    mobileCentersDirty=false;
  };
  const nativeActive=()=>{
    if(desktop()||!track||!this.slides.length)return;
    if(mobileCentersDirty)measureMobileSlides();
    const midpoint=track.scrollTop+track.clientHeight/2;
    let closest=0;
    // Group order is monotonic; a short linear scan avoids per-slide layout reads.
    while(closest+1<mobileSlideCenters.length &&
      Math.abs(mobileSlideCenters[closest+1]-midpoint)<Math.abs(mobileSlideCenters[closest]-midpoint))closest++;
    mark(closest);
  };
  track?.querySelectorAll('img').forEach(img=>{
    if(!img.complete)img.addEventListener('load',()=>{mobileCentersDirty=true},{once:true,passive:true});
  });
  const nativeScroll=()=>{
    if(nativeScrollRaf)return;
    nativeScrollRaf=requestAnimationFrame(()=>{
      nativeScrollRaf=0;
      nativeActive();
      if(!desktop()&&track){
        const max=Math.max(0,track.scrollHeight-track.clientHeight);
        const ratio=max>0?Math.min(1,Math.max(0,track.scrollTop/max)):1;
        const fill=this.querySelector('.wp-pdp__mobile-progress-fill');
        if(fill)fill.style.transform=`scaleY(${Math.max(.02,ratio)})`;
      }
    });
  };
  track?.addEventListener('scroll',nativeScroll,{passive:true});
  this._wpNativeGoTo=i=>{
    if(!track||desktop())return;
    const slide=this.slides[Math.max(0,Math.min(i,this.slides.length-1))];
    if(!slide)return;
    // Calculate inside the scrolling element, never use scrollIntoView:
    // that would also scroll the whole document and reveal the footer.
    const offset=slide.getBoundingClientRect().top-track.getBoundingClientRect().top;
    track.scrollTo({top:track.scrollTop+offset,behavior:'smooth'});
    mark(i);
  };
  this._wpNativeIsEnd=()=>!!track && track.scrollTop>=track.scrollHeight-track.clientHeight-3;
  this._wpSetGalleryLocked=locked=>{
    this._wpNativeGalleryLocked=!!locked;
    if(this.mainSwiper&&!desktop())this.mainSwiper.allowTouchMove=!locked;
  };
  this._wpNativeScrollCleanup=()=>{track?.removeEventListener('scroll',nativeScroll);cancelAnimationFrame(nativeScrollRaf);};

  this._desktopHeader=()=>{const h=document.querySelector('.section-header');const height=h?.getBoundingClientRect().height||75;this.style.setProperty('--wp-pdp-sticky-top',Math.max(65,Math.round(height))+'px')};this._desktopHeader();
  const init=()=>{
    if(this._wpWheelFrame){cancelAnimationFrame(this._wpWheelFrame);this._wpWheelFrame=0;}
    this.mainSwiper?.destroy(true,true);this.thumbSwiper?.destroy(true,true);this.mainSwiper=null;this.thumbSwiper=null;this._lastThumbIndex=-1;
    if(!desktop()){
      mobileCentersDirty=true;
      this._wpSetGalleryLocked?.(this.classList.contains('wp-pdp--sheet-open')||!!this._drawerIsOpen);
      nativeActive();
      return;
    }
    if(typeof window.Swiper!=='function')return;
    // Native overflow on the thumbnail rail reliably exposes images 6+ with
    // trackpad/mousewheel even when the site's Swiper mousewheel module is absent.
    // The main image gallery remains a Swiper instance.
    this.mainSwiper=new Swiper(this.gallery,{direction:'vertical',slidesPerView:'auto',spaceBetween:0,slidesOffsetAfter:16,speed:600,grabCursor:true,threshold:0,longSwipesRatio:.2,resistanceRatio:0,resizeObserver:false,freeMode:{enabled:true,sticky:false,momentum:true,momentumRatio:1.15,momentumVelocityRatio:1.15,momentumBounce:false},mousewheel:false,touchReleaseOnEdges:true,touchRatio:1.2,thumbs:this.thumbSwiper?{swiper:this.thumbSwiper}:undefined,on:{slideChange:s=>{this._suppressThumbSync=false;mark(s.activeIndex)},progress:s=>{ /* desktop indicator follows the active thumbnail in mark() */ }}});
    // Native Swiper free-mode duration: do not impose a 500ms minimum on quick flicks.
    // The previous setTransition/setTranslate wrappers caused momentum to feel sticky.
    const wheel=e=>{
      if(!desktop()||!this.mainSwiper||!this.isConnected)return;
      if(document.body.style.position==='fixed'||document.body.style.overflow==='hidden')return;
      if(thumbRail?.contains(e.target)){this._thumbWheelAt=Date.now();return}
      const rect=this.gallery.getBoundingClientRect();
      if(e.clientX<rect.left||e.clientX>rect.right||e.clientY<rect.top||e.clientY>rect.bottom)return;
      const swiper=this.mainSwiper;if(!e.deltaY)return;
      const current=swiper.translate,next=current-e.deltaY;
      const clamped=Math.min(swiper.minTranslate(),Math.max(swiper.maxTranslate(),next));
      // Always own wheel input above the gallery, including at both edges.
      // Otherwise the browser scrolls the full delta instead of only its overflow.
      if(e.cancelable)e.preventDefault();
      if(clamped!==current){swiper.setTransition(0);swiper.setTranslate(clamped);swiper.updateProgress(clamped);
        if(!this._wpWheelFrame)this._wpWheelFrame=requestAnimationFrame(()=>{this._wpWheelFrame=0;if(!this.mainSwiper)return;this.mainSwiper.updateActiveIndex();this.mainSwiper.updateSlidesClasses();this._suppressThumbSync=false;mark(this.mainSwiper.activeIndex)});
      }
      const overflow=next-clamped;
      if(Math.abs(overflow)>.01){
        // Swipe movement has reached an edge: give only the unused delta back
        // to the document, exactly as the reference gallery does.
        window.scrollBy({top:-overflow,behavior:'auto'});
      }
    };
    this._wpWheel=wheel;window.addEventListener('wheel',wheel,{capture:true,passive:false});
    mark(0);
  };
  this._wpMobileVerticalGallery=true;
  this._wpMediaMode=desktop();init();
   if(desktop()&&!this.mainSwiper){let attempts=0;this._wpSwiperRetry=setInterval(()=>{attempts++;if(this.mainSwiper||!this.isConnected||attempts>50){clearInterval(this._wpSwiperRetry);return}if(typeof window.Swiper==='function')init()},100)}
  this._wpResize=()=>{mobileCentersDirty=true;this._desktopHeader();if(desktop()!==this._wpMediaMode){this._wpMediaMode=desktop();if(this._wpWheel){window.removeEventListener('wheel',this._wpWheel,true);this._wpWheel=null}init()}else{if(!(this.classList.contains('wp-pdp--sheet-open')&&!desktop())){this.mainSwiper?.update();this.thumbSwiper?.update()}}};
  window.addEventListener('resize',this._wpResize,{passive:true});
  if(desktop()&&typeof window.Swiper!=='function'){
    // Fallback: preserve stacked photos if the CDN is blocked.
    this.classList.add('wp-pdp--swiper-fallback');
    this._fallbackObserver=new IntersectionObserver(entries=>{entries.forEach(en=>{if(en.isIntersecting)mark(this.slides.indexOf(en.target))})},{threshold:.3});this.slides.forEach(el=>this._fallbackObserver.observe(el));
  }
  mark(0);
 }

 animateToPhoto(target){
  if(this._photoAnimation)cancelAnimationFrame(this._photoAnimation);
  const start=window.scrollY, max=Math.max(0,document.documentElement.scrollHeight-window.innerHeight);
  const end=Math.max(0,Math.min(max,target)),distance=end-start;
  if(Math.abs(distance)<2)return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){window.scrollTo(0,end);return;}
  // Distance-sensitive slide animation: no abrupt jump on thumbnail hover.
  const duration=Math.min(1050,Math.max(350,350+Math.abs(distance)*.27));
  const begin=performance.now();
  const ease=t=>1-Math.pow(1-t,4);
  const step=now=>{const t=Math.min(1,(now-begin)/duration);window.scrollTo(0,start+distance*ease(t));
    if(t<1)this._photoAnimation=requestAnimationFrame(step);else this._photoAnimation=0;};
  this._photoAnimation=requestAnimationFrame(step);
 }
 initWishlist(){
  const button=this.querySelector('[data-wp-wishlist]');if(!button)return;
  const key='wp-pdp-wishlist-products',id=String(button.dataset.productId||'');
  const load=()=>{try{const value=JSON.parse(localStorage.getItem(key)||'[]');return Array.isArray(value)?value.map(String):[];}catch{return [];}};
  const render=()=>{const saved=window.WEAVEPLACEWishlist ? window.WEAVEPLACEWishlist.has(id) : load().includes(id);button.classList.toggle('is-saved',saved);button.setAttribute('aria-pressed',String(saved));button.setAttribute('aria-label',saved?'Remove from wishlist':'Add to wishlist');button.title=saved?'Remove from wishlist':'Add to wishlist';};
  button.addEventListener('click',()=>{if(!id)return;const values=new Set(load());if(values.has(id))values.delete(id);else values.add(id);try{localStorage.setItem(key,JSON.stringify([...values]));}catch{}render();});
  render();
 }
 // Shared purchase selection snapshot for desktop and mobile.
 // Shopify may provide a first available variant before a customer picks a size;
 // that fallback is only for displaying a preview price, never authorizes ATC.
 _wpSelectionState(){
  const groups=[...this.querySelectorAll('.wp-pdp__option')];
  const selections=groups.map(group=>group.querySelector('input:checked')?.value||'');
  const sizeGroup=this._wpSizeGroup();
  const sizeSelected=!sizeGroup||!!sizeGroup.querySelector('input:checked');
  const variant=sizeSelected?this.variants.find(v=>v.options.length===selections.length&&v.options.every((value,i)=>value===selections[i]))||null:null;
  const preview=variant||this.variants.find(v=>v.available)||this.variants[0]||null;
  return {groups,selections,sizeGroup,sizeSelected,variant,preview};
 }
 // One purchase decision for both layouts. The visual controls may differ,
 // but only a real customer-selected, available variant can be purchased.
 _wpPurchaseState(selection=this._wpSelectionState()){
  const variant=selection.variant;
  const hasSelection=!!variant;
  const available=hasSelection&&!!variant.available;
  return {
   ...selection,
   hasSelection,
   available,
   needsSize:!!selection.sizeGroup&&!selection.sizeSelected,
   soldOut:hasSelection&&!variant.available,
   displayVariant:variant||selection.preview,
   label:hasSelection?(available?'Add to Cart':'Sold Out'):'Add to Cart',
   canSubmit:available&&!this._cartSubmitting
  };
 }
 // Single renderer for desktop submit and mobile compact controls.
 // The purchase decision stays in _wpPurchaseState; each layout keeps its own UI.
 _wpRenderPurchaseButtons(purchase=this._wpPurchaseState()){
  if(this.atc&&!this._cartSubmitting){
   this.atc.disabled=purchase.soldOut;
   this.atc.setAttribute('aria-disabled',String(!purchase.canSubmit));
   if(this.label){
    const sizeWarning=this.querySelector('[data-size-warning]');
    this.label.textContent=purchase.needsSize&&sizeWarning&&!sizeWarning.hidden?'Select Size':purchase.label;
   }
  }
  this._wpSyncCompactButton();
 }
 initOptions(){
  // Ignore browser-restored radio selections for size on a fresh PDP load.
  this.querySelectorAll('.wp-pdp__sizes input[type=radio]').forEach(input=>{input.checked=false;input.defaultChecked=false;});
  this.querySelectorAll('.wp-pdp__option input').forEach(input=>input.addEventListener('change',()=>this.updateVariant(true,input)));
  this.updateVariant(false);
 }
 // Render swatch / size availability from the same current selections.
 _wpRenderOptionAvailability(selections,groups){
  groups.forEach((group,i)=>{
    const label=group.querySelector('[data-selected-label]');
    if(label)label.textContent=selections[i]||'';
    group.querySelectorAll('input').forEach(input=>{
      const partial=[...selections];partial[i]=input.value;
      const choices=this.variants.filter(v=>v.options.length===partial.length&&v.options.every((option,j)=>!partial[j]||option===partial[j]));
      const existsGlobally=this.variants.some(v=>v.options[i]===input.value);
      // Missing combinations are signposted, not disabled: users may change
      // color first, then size, without ending up trapped in the picker.
      const unavailable=choices.length===0||choices.every(v=>!v.available);
      input.disabled=!existsGlobally;
      input.closest('.wp-pdp__choice')?.classList.toggle('is-unavailable',unavailable);
      input.setAttribute('aria-label',`${input.value}${unavailable?' — '+(choices.length?'Sold Out':'Unavailable'):''}`);
    });
  });
 }
 updateVariant(updateUrl=true,changedInput=null){
  const state=this._wpPurchaseState();
  const groups=state.groups;
  let selections=state.selections;
  let variant=state.variant;
  // Selecting a color or size must not leave a nonexistent combination in the cart form.
  // Keep the newly selected option and preserve as many other selections as possible.
  if(!variant&&changedInput&&!groups.some(group=>group.querySelector('.wp-pdp__sizes')&&!group.querySelector('.wp-pdp__sizes input:checked'))){
    const index=groups.findIndex(group=>group.contains(changedInput));
    const alternatives=this.variants.filter(v=>v.options[index]===changedInput.value);
    alternatives.sort((a,b)=>{
      const score=v=>v.options.reduce((total,option,i)=>total+(i!==index&&option===selections[i]?1:0),0);
      return score(b)-score(a)||(Number(b.available)-Number(a.available));
    });
    if(alternatives.length){variant=alternatives[0];selections=[...variant.options];groups.forEach((group,i)=>{const match=[...group.querySelectorAll('input')].find(input=>input.value===selections[i]);if(match)match.checked=true;});}
  }
  if(!variant&&this.variants.length===1)variant=this.variants[0];
  this._wpRenderOptionAvailability(selections,groups);
  if(this.variantInput)this.variantInput.value=variant?.id||'';
  // Re-read after any option normalization so both controls use the same decision.
  const purchase=this._wpPurchaseState();
  this._wpRenderPurchaseButtons(purchase);
  if(this.availability)this.availability.textContent=variant&&!variant.available?'SOLD OUT':'';
  const previewVariant=variant||state.preview;
  this._wpRenderVariantPrice(previewVariant);
  const compactSwatches=this.querySelector('[data-compact-swatches]');
  if(compactSwatches){
    const colorField=groups.find(group=>group.querySelector('.wp-pdp__colors'));
    const selectedColor=colorField?.querySelector('input:checked')?.value;
    compactSwatches.querySelectorAll('[data-color-value]').forEach(el=>el.classList.toggle('is-current',el.dataset.colorValue===selectedColor));
  }
  if(variant){
    if(updateUrl){const url=new URL(window.location.href);url.searchParams.set('variant',variant.id);history.replaceState(history.state,'',url.pathname+url.search+url.hash);}
    if(variant.featured_media){const index=this.slides.findIndex(slide=>slide.dataset.mediaId===String(variant.featured_media.id)||slide.dataset.mediaIds?.split(',').includes(String(variant.featured_media.id)));if(index>=0&&this.gallery)this._wpGoToMedia?.(index);}
  }
  if(changedInput) this.querySelector('[data-size-warning]')?.setAttribute('hidden','');
  if(this.msg)this.msg.textContent='';
 }
 // Price is a single view of the selected variant (or preview before size choice).
 // Keep both desktop and compact/mobile amounts in sync without choosing a size.
 _wpRenderVariantPrice(variant){
  if(!variant)return;
  const formatted=this.formatMoney(variant.price);
  if(this.price)this.price.textContent=formatted;
  const compactPrice=this.querySelector('[data-compact-price]');
  if(compactPrice)compactPrice.textContent=formatted;
 }
 formatMoney(cents){
   const currency=this.dataset.currency||window.Shopify?.currency?.active||'TRY';
   const locale=document.documentElement.lang||'tr-TR';
   try{
     const formatted=new Intl.NumberFormat(locale,{style:'currency',currency}).format(cents/100);
     if(currency!=='TRY')return formatted;
     // Shopify keeps the active market currency; only TRY's symbol position is customized.
     const number=new Intl.NumberFormat(locale,{minimumFractionDigits:2,maximumFractionDigits:2}).format(cents/100);
     return number+'TL';
   }catch{return (cents/100).toFixed(2)+' '+(currency==='TRY'?'TL':currency);}
 }
  initMobilePanel(){
    const panel=this.info;
    const compact=panel?.querySelector('.wp-pdp__compact');
    const handle=this.querySelector('[data-panel-handle]');
    const galleryWrap=this.querySelector('.wp-pdp__gallery-wrap');
    const extended=panel?.querySelector('.wp-pdp__extended');
    const infoWrap=this.querySelector('.wp-pdp__info-wrap');
    if(!panel||!compact||!galleryWrap)return;
    const isMobile=()=>matchMedia('(max-width:1023px)').matches;
    const reduceMotion=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
    let opened=false, busy=false, gesture=null, edgeStart=null, settledTimer=null, lockedViewport=0;
    let openedFromGalleryEdge=false;
    let sheetHeight=0, collapsedHeight=128, headerBottom=0;
    const headerPos=()=>{
      const header=document.querySelector('.section-header') || document.querySelector('sticky-header') || document.querySelector('header.header');
      const rect=header?.getBoundingClientRect();
      return Math.max(0,Math.round(rect?.bottom||0));
    };
    // Safari's browser chrome changes window.innerHeight while the user scrolls.
    // 100svh is the stable, unobscured viewport height used by the reference PDP.
    // A browser without svh support keeps its previous innerHeight behavior.
    const stableViewportHeight=()=>{
      if(!window.CSS?.supports?.('height','100svh'))return Math.round(window.innerHeight);
      const probe=document.createElement('div');
      probe.style.cssText='position:fixed;top:0;left:0;height:100svh;width:0;visibility:hidden;pointer-events:none;z-index:-1;';
      document.body.appendChild(probe);
      const height=Math.round(probe.getBoundingClientRect().height);
      probe.remove();
      return height>0?height:Math.round(window.innerHeight);
    };
    const calculate=()=>{
      if(!isMobile()||busy||gesture)return;
      // Preserve the current size while expanded: mobile Safari's toolbar resize must
      // never trigger a Swiper reflow or change the photo's dimensions.
      if(opened)return;
      const panelStyle=getComputedStyle(panel);
      const handleStyle=handle?getComputedStyle(handle):null;
      const handleHeight=handle?.getBoundingClientRect().height||0;
      const handleMargin=(parseFloat(handleStyle?.marginTop)||0)+(parseFloat(handleStyle?.marginBottom)||0);
      // Measure the compact purchase card from its actual content on each
      // viewport. Do not inject filler padding below the Add to Cart button.
      // The measured height also drives the gallery / sheet boundary.
      panel.style.setProperty('--wp-panel-reveal-progress','0');
      compact.style.setProperty('--wp-compact-extra-space','0px');
      const measureCollapsed=()=>Math.ceil(handleHeight+handleMargin+compact.getBoundingClientRect().height+
        (parseFloat(panelStyle.paddingTop)||0)+(parseFloat(panelStyle.paddingBottom)||0));
      collapsedHeight=measureCollapsed();
      headerBottom=headerPos();
      // Size the media against the Safari-safe viewport (excluding mobile browser bars).
      // Keep it stable while browser chrome appears/disappears during scrolling.
      const vh=stableViewportHeight();
      lockedViewport=vh;
      sheetHeight=Math.max(260,vh-headerBottom);
      this.style.setProperty('--wp-compact-height',collapsedHeight+'px');
      this.style.setProperty('--wp-open-header-height',headerBottom+'px');
      this.style.setProperty('--wp-sheet-height',sheetHeight+'px');
      const top=galleryWrap.getBoundingClientRect().top;
      const photoHeight=Math.max(180,Math.round(vh-top-collapsedHeight));
      this.style.setProperty('--wp-mobile-gallery-height',photoHeight+'px');
      this.style.setProperty('--wp-locked-gallery-height',photoHeight+'px');
      panel.style.setProperty('--wp-sheet-shift',Math.max(0,sheetHeight-collapsedHeight)+'px');
      panel.style.setProperty('--wp-sheet-reveal-opacity','0.18');
      panel.classList.remove('wp-pdp--revealing','wp-pdp--crossfading');
      panel.style.removeProperty('--wp-compact-fade');
      panel.style.removeProperty('--wp-details-fade');
    };
    const shiftFor=(progress)=>Math.max(0,sheetHeight-collapsedHeight)*(1-progress);
    const setProgress=(progress)=>{
      const amount=Math.max(0,Math.min(1,progress));
      // Sync button spacing to the same reveal progress as the panel, as on
      // WEAVEPLACE's peek CTA. The collapsed card retains natural height.
      panel.style.setProperty('--wp-panel-reveal-progress',amount.toFixed(4));
      panel.style.setProperty('--wp-sheet-shift',shiftFor(amount)+'px');
      // The compact CTA and expanded information cross-fade as one continuous
      // scroll-driven transition. The compact card begins disappearing after
      // the first quarter of the travel and is gone before the sheet reaches top.
      const smooth=t=>{const x=Math.max(0,Math.min(1,t));return x*x*(3-2*x)};
      // Reveal details early enough that the rising white sheet never shows
      // a large empty band before the content becomes visible.
      const compactOpacity=1-smooth((amount-.10)/.42);
      const detailsOpacity=smooth((amount-.06)/.46);
      panel.style.setProperty('--wp-compact-fade',compactOpacity.toFixed(3));
      panel.style.setProperty('--wp-details-fade',detailsOpacity.toFixed(3));
      panel.style.setProperty('--wp-sheet-reveal-opacity',detailsOpacity.toFixed(3));
      // Keep both layers mounted at 0% and 100% while the finger is down.
      // Previously crossing 99.9% removed the reveal class and the compact
      // card snapped back before touchend, leaving details blank until settle.
      panel.classList.toggle('wp-pdp--revealing',
        panel.classList.contains('wp-pdp--dragging') ||
        panel.classList.contains('wp-pdp--crossfading') ||
        (amount>.005 && amount<.999));
    };
    // Reattach the fully-open panel from document flow to its fixed animation
    // layer BEFORE a reverse swipe/click.  Without this, dragging only changes
    // --wp-sheet-shift on a position:relative element whose transform is forced
    // to `none`, and removing flow-open later makes the entire sheet jump.
    // Keep the document-height occupied by the expanded sheet during the
    // fixed-layer reverse animation. Without this temporary placeholder the
    // gallery and footer shift as soon as flow-open is removed.
    const releaseFlowPlaceholder=()=>{
      if(!infoWrap)return;
      infoWrap.style.removeProperty('height');
      infoWrap.style.removeProperty('min-height');
      infoWrap.style.removeProperty('margin-top');
      infoWrap.style.removeProperty('overflow-anchor');
    };
    const prepareCloseFromFlow=()=>{
      if(!this.classList.contains('wp-pdp--flow-open'))return;
      if(infoWrap){
        const rect=infoWrap.getBoundingClientRect();
        const style=getComputedStyle(infoWrap);
        const preservedHeight=Math.max(sheetHeight,Math.ceil(rect.height));
        infoWrap.style.setProperty('height',preservedHeight+'px','important');
        infoWrap.style.setProperty('min-height',preservedHeight+'px','important');
        infoWrap.style.setProperty('margin-top',style.marginTop,'important');
        infoWrap.style.setProperty('overflow-anchor','none','important');
      }
      panel.classList.add('wp-pdp--crossfading');
      panel.style.setProperty('--wp-compact-fade','0');
      panel.style.setProperty('--wp-details-fade','1');
      panel.style.setProperty('--wp-sheet-reveal-opacity','1');
      panel.style.setProperty('--wp-sheet-shift','0px');
      this.classList.remove('wp-pdp--flow-open');
      document.body.classList.remove('wp-pdp-mobile-flow-ready');
    };
    const settle=(open)=>{
      if(!isMobile())return;
      // Reclaim a legacy flow-open sheet only if it actually exists.
      // Normal openings stay fixed, so closing needs no reparent/reflow.
      if(!open){prepareCloseFromFlow();document.body.classList.remove('wp-pdp-mobile-flow-ready');}
      clearTimeout(settledTimer);
      // Keep both contents mounted until the sheet finishes snapping.
      panel.classList.add('wp-pdp--crossfading');
      // On close, position the compact card at its final resting coordinates
      // BEFORE the sheet animation, avoiding a late absolute-to-flow jump.
      panel.classList.toggle('wp-pdp--settling-closed',!open);
      busy=true;opened=open;
      this.classList.toggle('wp-pdp--sheet-open',open);
      // Gallery stays at its selected image while the product sheet is expanded.
      // Do not destroy or update Swiper here: both would shift its image position.
      if(isMobile())this._wpSetGalleryLocked?.(open);
      // Do not switch the inner product layout to collapsed while the sheet
      // is still moving. That reflows labels, color chips and controls halfway
      // through the closing animation (the visible second downward slide).
      // Keep the expanded content geometry until the sheet reaches its stop.
      if(open)panel.classList.add('is-expanded');
      panel.dataset.expansion=open?'expanded':'closing';
      handle?.setAttribute('aria-expanded',String(open));
      panel.classList.remove('wp-pdp--dragging');
      if(open){
        // The extended content scrolls INSIDE the stable fixed card, never the gallery.
        if(extended)extended.scrollTop=0;
        panel.scrollTop=0;
      }
      // Force style reconciliation after dragging; transition stays transform-only.
      requestAnimationFrame(()=>setProgress(open?1:0));
      settledTimer=setTimeout(()=>{
        // Finalize layout only AFTER the movement has ended, while the closed
        // compact card is already fully opaque. Never reflow options mid-swipe.
        if(!opened){
          panel.classList.remove('is-expanded');
          panel.dataset.expansion='collapsed';
        }
        // Keep the exact closed geometry after the transition; dropping this
        // class at the end causes the whole white card to shift a few pixels.
        panel.classList.remove('wp-pdp--revealing','wp-pdp--crossfading');
        if(opened)panel.classList.remove('wp-pdp--settling-closed');
        // After the opening animation, release the sheet into document flow.
        // The recommendations and footer then follow the expanded information,
        // rather than sitting behind an independently scrolling fixed layer.
        if(opened && isMobile()){
          // Position-preserving handoff: the panel finishes its transform before
          // entering document flow; adjust scroll for any geometry difference.
          const before=panel.getBoundingClientRect().top;
          panel.style.setProperty('--wp-sheet-shift','0px');
          // Switch the gallery to an absolute underlay and the information
          // panel into normal flow as one layout operation. The gallery must
          // not leave a remnant strip before the recommendation section.
          this.classList.add('wp-pdp--flow-open');
          if(extended)extended.scrollTop=0;
          const after=panel.getBoundingClientRect().top;
          // Compensate for any scroll already performed over the gallery.
          if(Math.abs(after-before)>1)window.scrollBy(0,after-before);
          // Following sections become visible only after the flow handoff.
          document.body.classList.add('wp-pdp-mobile-flow-ready');
        }else{
          this.classList.remove('wp-pdp--flow-open');
          document.body.classList.remove('wp-pdp-mobile-flow-ready');
        }
        releaseFlowPlaceholder();
        busy=false;
        if(!opened){openedFromGalleryEdge=false;
          panel.scrollTop=0;
          // No gallery update on collapse; the gallery never changed its height.
        }
      },reduceMotion()?25:450);
    };
    const open=()=>{if(!this._drawerIsOpen&&!this._sizePopupOpen&&!opened&&!busy){openedFromGalleryEdge=false;calculate();settle(true)}};
    const close=()=>{if(!this._drawerIsOpen&&opened&&!busy){openedFromGalleryEdge=false;settle(false)}};
    this._wpPanelOpen=open;this._wpPanelClose=close;
    const onResize=()=>{
      if(!isMobile()){
        opened=false;busy=false;gesture=null;
        this._wpSetGalleryLocked?.(false);
        this.classList.remove('wp-pdp--sheet-open','wp-pdp--flow-open');
        document.body.classList.remove('wp-pdp-mobile-flow-ready');
        releaseFlowPlaceholder();
        panel.classList.remove('is-expanded','wp-pdp--dragging','wp-pdp--settling-closed');
        panel.style.removeProperty('--wp-sheet-shift');
        panel.style.removeProperty('--wp-panel-reveal-progress');
        panel.style.removeProperty('--wp-sheet-reveal-opacity');
        panel.style.removeProperty('--wp-compact-fade');
        panel.style.removeProperty('--wp-details-fade');
        panel.classList.remove('wp-pdp--revealing','wp-pdp--crossfading');
        return;
      }
      // Safari toolbar changes must not relayout the gallery. Actual orientation /
      // viewport-size changes modify 100svh and should trigger recalculation.
      if(Math.abs(stableViewportHeight()-lockedViewport)>2 || !lockedViewport)calculate();
    };
    this._wpCompactResize=onResize;
    window.addEventListener('resize',onResize,{passive:true});
    const observer=typeof ResizeObserver==='function'?new ResizeObserver(()=>{if(!opened&&!busy)calculate()}):null;
    observer?.observe(compact);
    this._wpCompactObserver=observer;
    document.fonts?.ready?.then(()=>{if(this.isConnected)calculate()});
    requestAnimationFrame(()=>calculate());
    this.querySelector('[data-open-panel]')?.addEventListener('click',e=>{
      e.preventDefault();e.stopPropagation();
      if(isMobile()){
        // The compact Add to Cart is NEVER the main product-sheet opener.
        // If sizes exist, show the independent chooser instead.
        if(this._wpColorToSize?.())return;
        const purchase=this._wpPurchaseState();
        if(purchase.available){this.addToCart(new Event('submit',{cancelable:true}));return;}
        if(purchase.soldOut)return;
        this.openMobileSizePicker();
        return;
      }
      open();
    });
    this.querySelector('.wp-pdp__compact-head')?.addEventListener('click',e=>{if(e.target.closest('[data-wp-open-mobile-colors]'))return;open();});
    handle?.addEventListener('click',()=>{if(opened)close();else open()});
    // Mobile vertical gestures over the horizontal gallery reveal the product sheet
    // instead of accidentally scrolling straight into related products/footer.
    // Horizontal gestures remain owned by Swiper.
    let verticalGalleryStart=null;
    this.gallery?.addEventListener('touchstart',e=>{
      if(this._wpMobileVerticalGallery)return;
      const t=e.touches[0];
      if(!t||e.touches.length!==1||!isMobile()||busy||this._drawerIsOpen||
        e.target.closest('button,a,input,[role="button"]')){verticalGalleryStart=null;return}
      verticalGalleryStart={x:t.clientX,y:t.clientY,vertical:false};
    },{passive:true,capture:true});
    this.gallery?.addEventListener('touchmove',e=>{
      if(this._wpMobileVerticalGallery)return;
      const g=verticalGalleryStart,t=e.touches[0];
      if(!g||!t||busy||this._drawerIsOpen)return;
      const dx=t.clientX-g.x,dy=t.clientY-g.y;
      if(!g.vertical){
        if(Math.abs(dx)>Math.abs(dy)*1.15 && Math.abs(dx)>7){verticalGalleryStart=null;return}
        if(Math.abs(dy)>9 && Math.abs(dy)>Math.abs(dx)*1.2)g.vertical=true;
      }
      // Both vertical directions must stay inside the PDP until the sheet
      // itself is open. Horizontal motion is still Swiper's responsibility.
      if(g.vertical&&e.cancelable)e.preventDefault();
    },{passive:false,capture:true});
    this.gallery?.addEventListener('touchend',e=>{
      if(this._wpMobileVerticalGallery)return;
      const g=verticalGalleryStart,t=e.changedTouches[0];verticalGalleryStart=null;
      if(!g||!t||!g.vertical||opened||busy||this._drawerIsOpen)return;
      if(g.y-t.clientY>45)open();
    },{passive:true,capture:true});
    this.gallery?.addEventListener('touchcancel',()=>{verticalGalleryStart=null},{passive:true});
    // One gesture, one animation: on the last gallery image do not drag the
    // product sheet at all. Safari and sheet transforms must not compete during
    // touchmove. Consume only the extra swipe, then start the opening animation.
    this.gallery?.addEventListener('touchstart',e=>{
      edgeStart=null;
      const t=e.touches[0];
      if(!t||e.touches.length!==1||!isMobile()||opened||busy||this._drawerIsOpen||this._sizePopupOpen)return;
      if(e.target.closest('button, a, input, [role=button]'))return;
      if(!this._wpNativeIsEnd?.())return;
      edgeStart={x:t.clientX,y:t.clientY,lastY:t.clientY,time:performance.now(),tracking:false};
    },{passive:true,capture:true});
    this.gallery?.addEventListener('touchmove',e=>{
      const s=edgeStart,t=e.touches[0];
      if(!s||!t||e.touches.length!==1||opened||busy)return;
      const up=s.y-t.clientY,dx=Math.abs(t.clientX-s.x);
      if(!s.tracking){
        if(dx>12&&dx>Math.abs(up)){edgeStart=null;return;}
        if(up<0){edgeStart=null;return;}
        if(up<9||up<dx*1.2)return;
        if(!this._wpNativeIsEnd?.()){edgeStart=null;return;}
        s.tracking=true;
      }
      if(e.cancelable)e.preventDefault();
      s.lastY=t.clientY;
    },{passive:false,capture:true});
    this.gallery?.addEventListener('touchend',e=>{
      const s=edgeStart,t=e.changedTouches[0];edgeStart=null;
      if(!s?.tracking||opened||busy)return;
      const up=s.y-(t?.clientY??s.lastY);
      const elapsed=Math.max(1,performance.now()-s.time);
      if(up<=42&&!(up>22&&up/elapsed>.65))return;
      openedFromGalleryEdge=true;
      // Keep the opened sheet on its fixed layer: switching to document flow
      // after 450ms causes the reported drop-and-rise on iOS/Android.
      calculate();
      settle(true);
    },{passive:true,capture:true});
    this.gallery?.addEventListener('touchcancel',()=>{edgeStart=null},{passive:true});
    // Finger-following drag on the handle, or downward swipe from the top of open content.
    // Prevent native document scrolling over the collapsed purchase card.
    // Panel's own drag listener (below) still receives every touch event.
    compact.addEventListener('touchmove',e=>{
      if(!isMobile()||opened||busy||this._drawerIsOpen||this._sizePopupOpen)return;
      if(e.touches.length===1&&e.cancelable)e.preventDefault();
    },{passive:false});
    panel.addEventListener('touchstart',e=>{
      if(!isMobile()||busy||this._drawerIsOpen||!e.touches[0])return;
      const t=e.touches[0];
      const fromHandle=!!e.target.closest('[data-panel-handle]');
      // The blank area of the collapsed white purchase card is also a drag
      // surface. Interactive controls retain their native tap behavior.
      const fromCompactBlank=!opened && !!e.target.closest('.wp-pdp__compact');
      if(!fromHandle && !fromCompactBlank && !(opened && (extended?.scrollTop||0)<=1))return;
      if(!fromHandle && e.target.closest('button, a, input, select, textarea, label, [role=button], [data-modal], .wp-pdp__option, [data-wp-open-mobile-colors], [data-open-panel]'))return;
      if(this._sizePopupOpen || this._wpMobileColorsOpen)return;
      // Do not reparent on touchstart: a tap or aborted gesture must not move
      // the gallery. Reattach only after the downward drag threshold.
      gesture={x:t.clientX,y:t.clientY,lastY:t.clientY,time:performance.now(),startOpen:opened,tracking:false,fromHandle};
    },{passive:true});
    panel.addEventListener('touchmove',e=>{
      const g=gesture,t=e.touches[0];if(this._drawerIsOpen){gesture=null;panel.classList.remove('wp-pdp--dragging');return}if(!g||!t)return;
      const dy=t.clientY-g.y,dx=Math.abs(t.clientX-g.x);
      if(!g.tracking){
        if(Math.abs(dy)<7||Math.abs(dy)<dx*1.2)return;
        if(g.startOpen&&dy<0){gesture=null;return}
        if(!g.startOpen&&dy>0){gesture=null;return}
        if(!g.fromHandle&&(extended?.scrollTop||0)>1){gesture=null;return}
        if(g.startOpen && this.classList.contains('wp-pdp--flow-open'))prepareCloseFromFlow();
        g.tracking=true;panel.classList.add('wp-pdp--dragging');
      }
      if(e.cancelable)e.preventDefault();
      g.lastY=t.clientY;
      const range=Math.max(1,sheetHeight-collapsedHeight);
      const progress=(g.startOpen?1:0)-dy/range;
      setProgress(progress);
    },{passive:false});
    const finishDrag=(e)=>{
      const g=gesture;gesture=null;if(this._drawerIsOpen){panel.classList.remove('wp-pdp--dragging');return}if(!g)return;
      if(!g.tracking){panel.classList.remove('wp-pdp--dragging');return}
      const dy=(e.changedTouches[0]?.clientY??g.lastY)-g.y;
      const elapsed=Math.max(1,performance.now()-g.time);
      const range=Math.max(1,sheetHeight-collapsedHeight);
      const targetProgress=(g.startOpen?1:0)-dy/range;
      // A decisive swipe wins over the midpoint; otherwise snap to the nearest state.
      // Previously the `|| targetProgress > .55` check could undo a deliberate
      // downward close gesture from the expanded state.
      const decisive= Math.abs(dy)>70 || Math.abs(dy)/elapsed>.7;
      const openNext=decisive ? dy<0 : targetProgress>.5;
      panel.classList.remove('wp-pdp--dragging');
      settle(openNext);
    };
    panel.addEventListener('touchend',finishDrag,{passive:true});
    panel.addEventListener('touchcancel',()=>{gesture=null;panel.classList.remove('wp-pdp--dragging');if(!this._drawerIsOpen)settle(opened)},{passive:true});
  }
  initDrawer(){
    this.overlay=this.querySelector('[data-overlay]');this.drawer=this.querySelector('[data-drawer]');if(this.overlay&&this.drawer){document.body.append(this.overlay,this.drawer)}this.drawerTitle=this.drawer?.querySelector('[data-drawer-title]');this.drawerContent=this.drawer?.querySelector('[data-drawer-content]');
    this.querySelectorAll('[data-modal]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();this.openDrawer(b.dataset.modal)}));
    this.drawer?.querySelector('[data-close-drawer]')?.addEventListener('click',e=>{e.preventDefault();this.closeDrawer()});
    this.overlay?.addEventListener('click',()=>this.closeDrawer());
    // Close when tapping anywhere outside the visible drawer (including the header).
    this._outsideDrawerPointer=e=>{if(this._drawerIsOpen&&this.drawer&&!this.drawer.contains(e.target))this.closeDrawer()};
    document.addEventListener('pointerdown',this._outsideDrawerPointer,true);
    this._keyHandler=e=>{if(e.key==='Escape'&&!this.drawer.hidden){e.preventDefault();this.closeDrawer()}if(e.key==='Tab'&&!this.drawer.hidden){const focusable=[...this.drawer.querySelectorAll('button,a[href],input:not([disabled]),[tabindex="0"]')].filter(x=>!x.disabled);if(!focusable.length)return;const first=focusable[0],last=focusable[focusable.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}}};
    document.addEventListener('keydown',this._keyHandler);
  }
  openDrawer(type){
    const template=this.querySelector(`[data-panel-${type}]`);if(!template||!this.drawer||!this.overlay)return;
    clearTimeout(this._drawerCloseTimer);
    this.info?.classList.remove('wp-pdp--dragging');
    this._drawerInvoker=document.activeElement;
    this.drawerTitle.textContent=type==='details'?'Details':type==='size'?'Size & Fit Guide':'Shipping, Exchanges and Returns';
    this.drawerContent.replaceChildren(template.content.cloneNode(true));
    this.overlay.hidden=false;this.drawer.hidden=false;this.drawer.setAttribute('aria-hidden','false');
    if(!this._drawerIsOpen){this._oldOverflow=document.body.style.overflow;this._drawerIsOpen=true;}
    if(matchMedia('(max-width:1023px)').matches)this._wpSetGalleryLocked?.(true);
    document.body.style.overflow='hidden';
    // Force a frame before entering, so the transition runs on both desktop and mobile.
    requestAnimationFrame(()=>requestAnimationFrame(()=>{if(this._drawerIsOpen){this.overlay.classList.add('is-open');this.overlay.style.setProperty('opacity','1','important');this.overlay.style.setProperty('visibility','visible','important');this.overlay.style.setProperty('pointer-events','auto','important');this.drawer.classList.add('is-open')}}));
    this.drawer?.querySelector('[data-close-drawer]')?.focus({preventScroll:true});
  }
  closeDrawer(){
    if(!this.drawer||this.drawer.hidden)return;
    this._drawerIsOpen=false;
    if(matchMedia('(max-width:1023px)').matches){
      this._wpSetGalleryLocked?.(this.classList.contains('wp-pdp--sheet-open'));
    }
    this.drawer.classList.remove('is-open');this.overlay.classList.remove('is-open');this.overlay.style.removeProperty('opacity');this.overlay.style.removeProperty('visibility');this.overlay.style.removeProperty('pointer-events');
    this.drawer.setAttribute('aria-hidden','true');document.body.style.overflow=this._oldOverflow||'';
    clearTimeout(this._drawerCloseTimer);
    const drawer=this.drawer,overlay=this.overlay;
    this._drawerCloseTimer=setTimeout(()=>{if(!this._drawerIsOpen){drawer.hidden=true;overlay.hidden=true}},430);
    if(this._drawerInvoker?.isConnected)this._drawerInvoker.focus({preventScroll:true});
  }
 _wpSyncCompactButton(){
   const button=this.querySelector('.wp-pdp__compact-btn');
   const label=this.querySelector('[data-compact-atc-label]');
   const price=this.querySelector('[data-compact-price]');
   if(!button||!label)return;
   // The desktop ATC and mobile compact control share ONE purchase-state
   // calculation. The hidden variant input is intentionally blank until size
   // selection, and must not be treated as an unavailable product.
   const purchase=this._wpPurchaseState();
   const busy=!!this._cartSubmitting;
   const chooserOpen=!!this._sizePopupOpen||!!this._wpColorIsOpen?.();
   button.classList.toggle('is-adding',busy);
   button.classList.toggle('is-size-selecting',!!this._sizePopupOpen&&!busy);
   button.setAttribute('aria-busy',String(busy));
   // No size selected means the mobile button opens the size chooser.
   // Only an explicitly chosen sold-out variant disables purchasing.
   button.disabled=busy||(purchase.soldOut&&!chooserOpen);
   if(busy)label.textContent='Adding to Cart...';
   else if(chooserOpen||purchase.needsSize)label.textContent='Select Size';
   else label.textContent=purchase.label;
   if(price){price.hidden=false;price.removeAttribute('hidden');}
 }
 initMobileSizePicker(){
   this.sizePopup=this.querySelector('[data-size-popup]');
   this.sizeShade=this.querySelector('[data-size-shade]');
   this.sizePopupOptions=this.querySelector('[data-size-popup-options]');
   this.mobileAdded=this.querySelector('[data-mobile-added]');
   if(!this.sizePopup||!this.sizeShade)return;
   // The product component has independent gallery/flow stacking contexts.
   // Mount the three fixed layers at document level to keep the dimmer visible.
   // Keep original node references; all listeners remain attached to the nodes.
   // The sliding size chooser is clipped precisely at the compact card's top.
   // This makes it emerge from BEHIND the white card, not over its contents.
   this.sizeClip=document.createElement('div');
   this.sizeClip.className='wp-pdp__size-clip';
   document.body.appendChild(this.sizeClip);
   this.sizeClip.appendChild(this.sizePopup);
   // Notification is clipped BELOW the header, not animated across its face.
   if(this.mobileAdded){
     this.mobileAddedClip=document.createElement('div');
     this.mobileAddedClip.className='wp-pdp__added-clip';
     document.body.appendChild(this.mobileAddedClip);
     this.mobileAddedClip.appendChild(this.mobileAdded);
   }
   if(this.sizeShade && this.sizeShade.parentElement!==document.body)document.body.appendChild(this.sizeShade);
   this._wpSyncSizeLayerPosition=()=>{
     const compact=this.querySelector('[data-mobile-panel]');
     if(!compact)return;
     const rect=compact.getBoundingClientRect();
     const bottomGap=Math.max(0,Math.round(window.innerHeight-rect.top));
     const header=this.querySelector('.wp-pdp__gallery-wrap');
     const headerBottom=Math.max(0,Math.round(document.querySelector('.section-header')?.getBoundingClientRect().bottom||40));
     this.sizeClip?.style.setProperty('--wp-size-compact-bottom',bottomGap+'px');
     this.sizeClip?.style.setProperty('--wp-size-header-bottom',headerBottom+'px');
     this.sizeShade?.style.setProperty('--wp-size-compact-bottom',bottomGap+'px');
     this.sizeShade?.style.setProperty('--wp-size-header-bottom',headerBottom+'px');
     if(this.mobileAdded)this.mobileAdded.style.setProperty('--wp-size-header-bottom',headerBottom+'px');
   };
   this._wpSyncSizeLayerPosition();
   window.addEventListener('resize',this._wpSyncSizeLayerPosition);
   // Freeze native document/gallery scrolling while the size chooser is visible.
   // These capture listeners run before Swiper and panel gesture handlers.
   // Do not intercept taps/clicks: sizes, backdrop and handle remain functional.
   this._wpSizeBlockScroll=event=>{
     if(!this._sizePopupOpen && !this._wpSizeClosing)return;
     if(event.cancelable)event.preventDefault();
   };
   document.addEventListener('touchmove',this._wpSizeBlockScroll,{capture:true,passive:false});
   document.addEventListener('wheel',this._wpSizeBlockScroll,{capture:true,passive:false});
   this._wpLockSizeScroll=()=>{
     if(this._wpSizeScrollStyles)return;
     const html=document.documentElement,body=document.body;
     this._wpSizeScrollStyles={htmlOverflow:html.style.overflow,bodyOverflow:body.style.overflow,
       htmlOverscroll:html.style.overscrollBehavior,bodyOverscroll:body.style.overscrollBehavior};
     html.style.overflow='hidden';body.style.overflow='hidden';
     html.style.overscrollBehavior='none';body.style.overscrollBehavior='none';
   };
   this._wpUnlockSizeScroll=()=>{
     const prior=this._wpSizeScrollStyles;if(!prior)return;
     const html=document.documentElement,body=document.body;
     html.style.overflow=prior.htmlOverflow;body.style.overflow=prior.bodyOverflow;
     html.style.overscrollBehavior=prior.htmlOverscroll;body.style.overscrollBehavior=prior.bodyOverscroll;
     this._wpSizeScrollStyles=null;
   };
   this._sizeSelectedForAutoAdd=false;
   this.sizeShade.addEventListener('click',()=>this.closeMobileSizePicker());
   this.sizeShade.addEventListener('touchmove',e=>{if(this._sizePopupOpen&&e.cancelable)e.preventDefault()},{passive:false});
   this.sizePopup.querySelector('[data-close-size-popup]')?.addEventListener('click',(event)=>{
     // Prevent the browser's pressed/focus highlight from lingering above the
     // animating white size sheet after the handle is tapped.
     event.preventDefault();
     event.currentTarget.blur();
     this.closeMobileSizePicker();
   });
   this.sizePopup.querySelector('[data-size-popup-guide]')?.addEventListener('click',()=>{this.closeMobileSizePicker();this.openDrawer('size')});
   document.addEventListener('keydown',this._wpSizeEscape=e=>{if(e.key==='Escape'&&this._sizePopupOpen)this.closeMobileSizePicker()});
   // Coordinate the elevated size chooser with the global header overlays.
   // Intercept only the FIRST click while size selection is open; let its
   // 350ms closing transition finish before activating the requested control.
   // Synthetic replay is guarded so the original header/cart listeners work
   // exactly as before and no duplicate drawer requests are made.
   this._wpHeaderSwitchPending=false;
   this._wpSizeHeaderClick=e=>{
     if(!this._sizePopupOpen || this._wpHeaderSwitchPending || !this.isConnected)return;
     const target=e.target instanceof Element ? e.target : e.target?.parentElement;
     const trigger=target?.closest('#cart-icon-bubble, header-drawer summary.header__icon--menu, menu-drawer summary.header__icon--menu, .header__icon--menu');
     if(!trigger)return;
     e.preventDefault();
     e.stopImmediatePropagation();
     this._wpHeaderSwitchPending=true;
     this.closeMobileSizePicker();
     clearTimeout(this._wpHeaderSwitchTimer);
     this._wpHeaderSwitchTimer=setTimeout(()=>{
       this._wpHeaderSwitchPending=false;
       if(trigger.isConnected)trigger.click();
     },370);
   };
   document.addEventListener('click',this._wpSizeHeaderClick,true);

   // The handle is click-only. Dragging it previously changed the popup
   // transform while the underlying gallery/page could still scroll.
   // The existing [data-close-size-popup] click listener above handles closing.

 }
 _wpSizeGroup(){
   // Prefer the semantic class Liquid applies to the picker. Shopify option
   // labels can be translated or customized, so don't rely on 'Size' text alone.
   return this.querySelector('.wp-pdp__option:has(.wp-pdp__sizes)') ||
     [...this.querySelectorAll('.wp-pdp__option')].find(el=>/size|beden|taille|größe|taglia/i.test(el.querySelector('legend')?.textContent||''));
 }
 _wpHasSizeOption(){return !!this._wpSizeGroup();}
 _wpBeginShadeHandoff(){
   // Keep the backdrop's 30% opacity constant while exchanging sheet ownership.
   // Both shade elements are body portals; switching their visible state in one
   // rendering frame prevents the white flash from two independent fades.
   clearTimeout(this._wpShadeHandoffTimer);
   this._wpShadeHandoffActive=true;
   document.body.classList.add('wp-pdp-shade-handoff');
   this._wpShadeHandoffTimer=setTimeout(()=>{
     this._wpShadeHandoffActive=false;
     document.body.classList.remove('wp-pdp-shade-handoff');
   },80);
 }
 openMobileSizePicker(){
   if(!this.sizePopup||this._cartSubmitting||this._sizePopupOpen)return;
   const group=this._wpSizeGroup();
   // Do not open the main sheet as a fallback: that was the reported v12 bug.
   if(!group){
     // A no-size product can be submitted directly (default/one-size variant).
     if(this.variantInput?.value && !this._cartSubmitting){
       this._sizeSelectedForAutoAdd=true;
       this._pendingMobileSize='';
       this.addToCart(new Event('submit',{cancelable:true}));
     }
     return;
   }
   const options=group.querySelectorAll('.wp-pdp__choice input');
   this.sizePopupOptions.replaceChildren();
   for(const input of options){
     const option=document.createElement('button');option.type='button';option.textContent=input.value;
     option.className='wp-pdp__size-popup-choice';option.setAttribute('aria-label',`Select size ${input.value}`);
     if(input.closest('.wp-pdp__choice')?.classList.contains('is-unavailable'))option.classList.add('is-unavailable');
     if(input.checked)option.classList.add('is-selected');
     option.setAttribute('aria-pressed',input.checked?'true':'false');
     option.addEventListener('click',()=>{
       if(this._cartSubmitting)return;
       this.sizePopupOptions.querySelectorAll('.wp-pdp__size-popup-choice').forEach(el=>{el.classList.remove('is-selected');el.setAttribute('aria-pressed','false')});
       option.classList.add('is-selected');option.setAttribute('aria-pressed','true');
       input.checked=true;input.dispatchEvent(new Event('change',{bubbles:true}));
       const v=this.variants.find(v=>String(v.id)===String(this.variantInput?.value));
       if(!v?.available){const error=this.sizePopup.querySelector('[data-size-popup-error]');if(error){error.textContent='Selected size is sold out';error.hidden=false;}return;}
       this._sizeSelectedForAutoAdd=true;this._pendingMobileSize=input.value;
       // Keep the chooser and dimmer visible while Shopify processes the add.
       // A successful confirmation bar, not the size tap, triggers closing.
       const error=this.sizePopup.querySelector('[data-size-popup-error]');if(error)error.hidden=true;
       this.addToCart(new Event('submit',{cancelable:true}));
     });
     this.sizePopupOptions.appendChild(option);
   }
   const error=this.sizePopup.querySelector('[data-size-popup-error]');if(error)error.hidden=true;
   // Reflect the currently selected Shopify size each time the sheet opens.
   this.sizePopupOptions.querySelectorAll('.wp-pdp__size-popup-choice').forEach(choice=>{
     const selected=Array.from(options).some(input=>input.checked && input.value===choice.textContent.trim());
     choice.classList.toggle('is-selected',selected);
     choice.setAttribute('aria-pressed',selected?'true':'false');
   });
   this._sizePopupOpen=true;
   this._wpSizeClosing=false;
   this._wpLockSizeScroll();
   this._wpSyncCompactButton(this.variants.find(v=>String(v.id)===String(this.variantInput?.value)));
   this._wpSyncSizeLayerPosition?.();
   this.classList.add('wp-pdp--size-open');
   clearTimeout(this._wpSizeCloseTimer);
   this.sizePopup.hidden=false;this.sizeShade.hidden=false;
   if(this._wpShadeHandoffActive)this.sizeShade.classList.add('is-visible');
   requestAnimationFrame(()=>{this.sizePopup.classList.add('is-visible');this.sizeShade.classList.add('is-visible')});
 }
 closeMobileSizePicker(){
   if(!this._sizePopupOpen)return;
   this._sizePopupOpen=false;
   this._wpSizeClosing=true;
   this._wpSyncCompactButton(this.variants.find(v=>String(v.id)===String(this.variantInput?.value)));
   this.sizePopup.style.removeProperty('--wp-size-drag');
   this.sizePopup.classList.remove('is-visible');this.sizeShade.classList.remove('is-visible');
   clearTimeout(this._wpSizeCloseTimer);
   this._wpSizeCloseTimer=setTimeout(()=>{if(!this._sizePopupOpen){this.sizePopup.hidden=true;this.sizeShade.hidden=true;this.classList.remove('wp-pdp--size-open');this._wpSizeClosing=false;this._wpUnlockSizeScroll?.();}},400);
 }
 async _wpRefreshHeaderCartCount(){
   try{
     const response=await fetch(window.routes?.cart_url ? window.routes.cart_url.replace(/\/$/,'')+'.js' : '/cart.js',{credentials:'same-origin',cache:'no-store'});
     if(!response.ok)return;
     const cart=await response.json();
     const icon=document.getElementById('cart-icon-bubble');
     if(!icon||!Number.isFinite(cart.item_count))return;
     let bubble=icon.querySelector('.cart-count-bubble');
     if(cart.item_count<1){bubble?.remove();return;}
     if(!bubble){bubble=document.createElement('div');bubble.className='cart-count-bubble';icon.appendChild(bubble);}
     bubble.replaceChildren();
     if(cart.item_count<100){const visual=document.createElement('span');visual.setAttribute('aria-hidden','true');visual.textContent=String(cart.item_count);bubble.appendChild(visual);}
     const sr=document.createElement('span');sr.className='visually-hidden';sr.textContent=String(cart.item_count)+' items in cart';bubble.appendChild(sr);
   }catch(error){console.warn('[WEAVEPLACE PDP] Header cart count refresh failed',error);}
 }
 showMobileAdded(size){
   if(!this.mobileAdded)return;
   const toast=this.mobileAdded;
   toast.querySelector('[data-mobile-added-size]').textContent='SIZE '+String(size||'');
   clearTimeout(this._wpAddedTimer);
   clearTimeout(this._wpAddedHideTimer);
   if(this._wpAddedFrame)cancelAnimationFrame(this._wpAddedFrame);
   // Anchor to the header's actual bottom; never let browser bars shift it.
   const header=document.querySelector('.section-header') || document.querySelector('sticky-header') || document.querySelector('header.header');
   const bottom=header?.getBoundingClientRect().bottom;
   this.mobileAddedClip?.style.setProperty('--wp-added-header-bottom',Math.max(0,Math.round(Number.isFinite(bottom)?bottom:parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'))||40))+'px');
   toast.classList.remove('is-visible');
   toast.hidden=false;
   // Commit the fully retracted state before transitioning into view.
   void toast.offsetHeight;
   this._wpAddedFrame=requestAnimationFrame(()=>{
     this._wpAddedFrame=0;
     if(!toast.isConnected)return;
     toast.classList.add('is-visible');
     this._wpAddedTimer=setTimeout(()=>{
       toast.classList.remove('is-visible');
       this._wpAddedHideTimer=setTimeout(()=>{
         if(!toast.classList.contains('is-visible'))toast.hidden=true;
       },460);
     },3300);
   });
 }
 // Centralized presentation of cart request states. Purchase eligibility stays in
 // _wpPurchaseState; this helper only updates existing desktop/mobile UI.
 _wpRenderCartFeedback(phase, {variant=null, message='', silentMobile=false}={}){
  const submitting=phase==='adding';
  if(this.atc){
   this.atc.disabled=submitting;
   if(submitting)this.atc.setAttribute('aria-busy','true');
   else this.atc.removeAttribute('aria-busy');
  }
  if(this.label){
   if(phase==='adding')this.label.textContent='Adding to Cart…';
   else if(phase==='success')this.label.textContent='Added to Bag';
  }
  if(this.msg){
   this.msg.textContent=message;
   if(phase==='error')this.msg.setAttribute('role','alert');
   else this.msg.removeAttribute('role');
  }
  if(phase==='error'&&silentMobile){
   const box=this.sizePopup?.querySelector('[data-size-popup-error]');
   if(box){box.textContent=message||'Could not add to cart';box.hidden=false;}
  }
  this._wpSyncCompactButton(variant);
 }
 async addToCart(e){
  e.preventDefault();
  if(this._cartSubmitting||!this.form||!this.atc||!this.variantInput)return;
  const state=this._wpPurchaseState();
  const selected=state.variant;
  const id=selected?.id;
  if(!state.available){
    if(state.needsSize){
      const warning=this.querySelector('[data-size-warning]');
      if(warning){warning.hidden=false;warning.textContent='Select Your Size';}
      if(this.label)this.label.textContent='Select Size';
      if(this.msg){this.msg.textContent='';this.msg.removeAttribute('role');}
      return;
    }
    this.updateVariant(false);
    if(this.msg)this.msg.textContent='Seçilen ürün seçeneği şu anda satışta değil.';
    return;
  }
  const silentMobile=this._sizeSelectedForAutoAdd&&matchMedia('(max-width:1023px)').matches;
  this._sizeSelectedForAutoAdd=false;
  this._cartSubmitting=true;
  this._wpRenderCartFeedback('adding',{variant:selected});
  const formData=new FormData(this.form);
  formData.set('id',id);
  try{
    const response=await fetch(window.routes?.cart_add_url||'/cart/add.js',{
      method:'POST',
      headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json',...(silentMobile?{'X-WP-PDP-Mobile':'1'}:{})},
      body:formData
    });
    let result;
    try{result=await response.json();}catch{result=null;}
    if(!response.ok||!result||result.status){
      throw new Error(result?.description||result?.message||'Ürün sepete eklenemedi. Lütfen tekrar deneyin.');
    }
    this._wpRenderCartFeedback('success',{variant:selected,message:''});
    // cart-drawer.js observes successful /cart/add requests and opens/refetches
    // the existing Shopify drawer. Do not render or open it a second time here.
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:{item:result,silent:silentMobile}}));
    // Refresh the shared header count for both desktop and mobile after a
    // successful Shopify add. Drawer refresh is independent and must not block it.
    const headerCountRefresh=this._wpRefreshHeaderCartCount();
    if(silentMobile) await headerCountRefresh;
    if(silentMobile){
      this.showMobileAdded(this._pendingMobileSize);
      // The notification is made visible first; the size sheet then retreats
      // behind the compact product card with the same closing animation.
      requestAnimationFrame(()=>this.closeMobileSizePicker());
    }
  }catch(error){
    this._wpRenderCartFeedback('error',{
      variant:selected,message:error?.message||'Bir bağlantı hatası oluştu.',silentMobile
    });
  }finally{
    const status=this.msg?.textContent||'';
    const isError=this.msg?.getAttribute('role')==='alert';
    this._cartSubmitting=false;
    this._wpRenderCartFeedback('idle',{
      variant:this.variants.find(v=>String(v.id)===String(this.variantInput?.value))
    });
    this.updateVariant(false);
    if(this.msg){this.msg.textContent=status;if(isError)this.msg.setAttribute('role','alert');else this.msg.removeAttribute('role');}
  }
 }
 disconnectedCallback(){if(this._wpGalleryVisibility)document.removeEventListener('visibilitychange',this._wpGalleryVisibility);this.gallery?.querySelectorAll('video.wp-pdp__video').forEach(video=>video.pause());if(this._wpPurchaseResize)window.removeEventListener('resize',this._wpPurchaseResize);clearTimeout(this._wpShadeHandoffTimer);document.body.classList.remove('wp-pdp-shade-handoff');this._wpCloseMobileColors?.();if(this._wpMobileColorKey)document.removeEventListener('keydown',this._wpMobileColorKey);if(this._wpMobileColorResize)window.removeEventListener('resize',this._wpMobileColorResize);this.mobileColorsClip?.remove();this.mobileColorsPanel?.remove();this.mobileColorsShade?.remove();if(this._wpSyncMobileColors){window.removeEventListener('resize',this._wpSyncMobileColors);window.visualViewport?.removeEventListener('resize',this._wpSyncMobileColors);}this._wpUnlockSizeScroll?.();if(this._wpSizeBlockScroll){document.removeEventListener('touchmove',this._wpSizeBlockScroll,true);document.removeEventListener('wheel',this._wpSizeBlockScroll,true);}if(this._wpSizeHeaderClick)document.removeEventListener('click',this._wpSizeHeaderClick,true);clearTimeout(this._wpHeaderSwitchTimer);if(this._wpSyncSizeLayerPosition)window.removeEventListener('resize',this._wpSyncSizeLayerPosition);for(const layer of [this.sizeShade,this.sizePopup,this.mobileAddedClip,this.sizeClip])layer?.remove();clearTimeout(this._wpSizeCloseTimer);clearTimeout(this._wpAddedTimer);clearTimeout(this._wpAddedHideTimer);if(this._wpAddedFrame)cancelAnimationFrame(this._wpAddedFrame);if(this._wpSizeEscape)document.removeEventListener('keydown',this._wpSizeEscape);this._wpCompactObserver?.disconnect();if(this._wpCompactResize){window.removeEventListener('resize',this._wpCompactResize);window.visualViewport?.removeEventListener('resize',this._wpCompactResize);}if(this._photoAnimation)cancelAnimationFrame(this._photoAnimation);this._mediaObserver?.disconnect();if(this._wpResize)window.removeEventListener('resize',this._wpResize);if(this._wpWheel)window.removeEventListener('wheel',this._wpWheel,true);if(this._wpWheelFrame)cancelAnimationFrame(this._wpWheelFrame);this.mainSwiper?.destroy(true,true);this.thumbSwiper?.destroy(true,true);this._wpNativeScrollCleanup?.();this._fallbackObserver?.disconnect();if(this._keyHandler)document.removeEventListener('keydown',this._keyHandler);if(this._outsideDrawerPointer)document.removeEventListener('pointerdown',this._outsideDrawerPointer,true);if(this._wpMobileMediaChange)window.removeEventListener('resize',this._wpMobileMediaChange);if(this._wpSwiperRetry)clearInterval(this._wpSwiperRetry);this.overlay?.remove();this.drawer?.remove();clearTimeout(this._drawerCloseTimer);}
}
if(!customElements.get('weaveplace-product'))customElements.define('weaveplace-product',WeaveplaceProduct);
})();
